<template lang="pug"> 
v-layout( fill-height)
  v-container( fluid  fill-height)
      v-layout( align-center justify-center)
        v-flex( xs12 sm8 md4) 
            v-card( class="elevation-12")
              v-card-title  Bienvenido   
              v-divider
              v-card-text  Portal de Ingreso
              v-card-text 
                  v-form 
                    v-text-field( 
                        prepend-icon="mdi-email"
                        name="login"
                        label="Login"
                        type="text"
                        v-model="user") 
                    v-text-field(
                        prepend-icon="mdi-lock"
                        id="password" 
                        name="password"
                        label="Password"
                        v-model="password"
                        type="password"
                        @keypress.enter="login()")  
              v-card-actions
                  v-spacer 
                  v-btn.bg-menu.text-white(color="primary" @click="login()"   block ) INICIAR 
//- transition(name='modal')
//-   .modal-mask
//-     .container
//-       .row.vertical-offset-100
//-         .col-md-5.offset-md-4
//-             .card 
//-               .card-header.bg-menu.text-white
//-                 .card-title
//-                     h2 Bienvenido! 
//-               .card-body
//-                 fieldset(style="padding:10px")
//-                     .form-group
//-                         h4 LOGIN
//-                     .form-group                          
//-                     .form-group
//-                         input.form-control(placeholder='Usuario', v-model="user", :readonly="validando")
//-                     .form-group
//-                         input.form-control(placeholder='Password', v-model="password",type="password",@keypress.enter="login()", :readonly="validando")
//-                     .from-group.text-center
//-                         button.btn.btn-lg.bg-menu.text-white(@click="login()", :disabled="validando") {{btnTexto}}
</template>
<script>
import apiWeb from "../../../api/apiSLCLogin.js"
import tools from "../../../tools/loadMenu.js"
import Vue from "vue";
import axios from 'axios'
import SHA3 from 'crypto-js/sha512';

const url = 'https://api.ipify.org?format=json'

export default {
    data(){
        return{
            user:'',
            password:'',
            message:'',
            validando:false,
            btnTexto:'ENTRAR',
            ip:'',
            Info:{},
            menu:[]
        }
    },
    mounted(){ 
        if(typeof Vue.prototype.$info==='undefined')
        {
            this.$emit("login")
        }
        axios.get(url)
             .then(
                 d=>{
                     if(d.data)
                     {
                         this.ip=d.data.ip
                     }
                 }
             )       

    },
    methods:{
        login(){
            this.validando=true
            this.btnTexto="VALIDANDO..."

            
            apiWeb.post("Login/Authenticate",{Email:this.user, Password:SHA3(this.password).toString()})
                    .then(r=>{
                        if(r.status==0)
                        {
                            Vue.prototype.$info=r.value 
                            Vue.prototype.$info.ip=this.ip
                            this.$info=r.value
                            this.$info.ip=this.ip
                            console.log("Antes de")
                            tools.loadMenu(this.$router,Vue.prototype.$info.typeAccount,Vue.prototype.$info.idEnterprise)
                            console.log("paso paso")
                            this.$cookies.set("cookieSLC",r.value);
                            this.createMenu()
                            this.$emit("login",this.menu)
                        }
                        else{
                            this.$msgbox.show(r.errorMessage,"Error")
                            this.validando=false
                            this.btnTexto='ENTRAR'
                        }

                    })
                    .catch(ex=> { 
                                this.$msgbox.show(ex.message,"Error")
                                this.validando=false
                                this.btnTexto='ENTRAR'
                                }
                        )
        },
        createMenu(){
          try{
            console.log("menu de rutas")
this.menu={item: (this.$info.typeAccount==6 || this.$info.typeAccount==2 || this.$info.typeAccount==3 )? [{
                  "Id":3,
                  "Name":"Reportes",
                  "Class":"fa fa-bar-chart NavIcon",
                  "Tipo":3,"NavGroup":0
                  },
                  {
                  "Id":4,
                  "Name":"Otros",
                  "Class":"fa fa-external-link NavIcon",
                  "Tipo":3,"NavGroup":0
                  } ]:  [
                  {
                  "Id":1,
                  "Name":"Listas",
                  "Class":"fa fa-file-text NavIcon",
                  "Tipo":2,"NavGroup":0
                  },
                  {
                  "Id":2,
                  "Name":"Administracion",
                  "Class":"fa fa-laptop NavIcon",
                  "Tipo":2,"NavGroup":0
                  }, 
                  {
                  "Id":3,
                  "Name":"No Conformidades",
                  "Class":"fa fa-list-alt NavIcon",
                  "Tipo":2,"NavGroup":0
                  }, 
                  {
                  "Id":4,
                  "Name":"Reportes",
                  "Class":"fa fa-bar-chart NavIcon",
                  "Tipo":3,"NavGroup":0
                  } ,
                  ,
                  {
                  "Id":5,
                  "Name":"Otros",
                  "Class":"fa fa-external-link NavIcon",
                  "Tipo":3,"NavGroup":0
                  }
                ],
            subitem:(this.$info.typeAccount==6)? [{
                    "Id_Item":4,
                    "Name":"Report Power BI",
                    "Path":"/reportUrl",
                    "Component":"reportUrl/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                    {
                      "Id_Item":5,
                      "Name":"Link",
                      "Path":"/link",
                      "Component":"link/",
                      "SubNavGroup":0,
                      "Sub_name":null
                    } ] : (this.$info.typeAccount==2 || this.$info.typeAccount==3) ? [
                    {
                      "Id_Item":4,
                      "Name":"Informes",
                      "Path":"/report",
                      "Component":"report/",
                      "SubNavGroup":0,
                      "Sub_name":null
                    },
                    {
                      "Id_Item":5,
                      "Name":"Link",
                      "Path":"/link",
                      "Component":"link/",
                      "SubNavGroup":0,
                      "Sub_name":null
                    },
                  {
                    "Id_Item":4,
                    "Name":"No-Conformidades Cerradas",
                    "Path":"/non-conformingReportClosure",
                    "Component":"non-conformingReportClosure/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":3,
                    "Name":"Pendientes",
                    "Path":"/nonConformitiesPending",
                    "Component":"nonConformitiesPending/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":3,
                    "Name":"Cerradas",
                    "Path":"/nonConformitiesClosed",
                    "Component":"nonConformitiesClosed/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":4,
                    "Name":"No-Conformidades Pendietes",
                    "Path":"/non-conformingReportPending",
                    "Component":"non-conformingReportPending/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  }
                  ] :
                    [                  
                    this.$info.typeAccount==4 ? {
                    "Id_Item":2,
                    "Name":"Empresas",
                    "Path":"/enterprise",
                    "Component":"enterprise/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  }:{},
                  {
                    "Id_Item":2,
                    "Name":"Mantenedor Metas",
                    "Path":"/goalsso",
                    "Component":"Mantenedor Metas/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":3,
                    "Name":"Pendientes",
                    "Path":"/nonConformitiesPending",
                    "Component":"nonConformitiesPending/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":3,
                    "Name":"Cerradas",
                    "Path":"/nonConformitiesClosed",
                    "Component":"nonConformitiesClosed/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":2,
                    "Name":"Oficinas",
                    "Path":"/branchOffices",
                    "Component":"officines/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":2,
                    "Name":"Usuarios",
                    "Path":"/users",
                    "Component":"users/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":2,
                    "Name":"Divisiones",
                    "Path":"/division",
                    "Component":"division/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":2,
                    "Name":"Usuarios Report",
                    "Path":"/usersReport",
                    "Component":"usersReport/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":2,
                    "Name":"Perfiles",
                    "Path":"/profiles",
                    "Component":"profiles/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":1,
                    "Name":"Tipo Documentos",
                    "Path":"/docType",
                    "Component":"docType/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  }, 
                  {
                    "Id_Item":1,
                    "Name":"Listas Desplegables",
                    "Path":"/docListSelect",
                    "Component":"docListSelect/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  }, 
                  {
                    "Id_Item":4,
                    "Name":"Informes",
                    "Path":"/report",
                    "Component":"report/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },
                  {
                    "Id_Item":4,
                    "Name":"No-Conformidades Cerradas",
                    "Path":"/non-conformingReportClosure",
                    "Component":"non-conformingReportClosure/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },{
                    "Id_Item":4,
                    "Name":"No-Conformidades Pendietes",
                    "Path":"/non-conformingReportPending",
                    "Component":"non-conformingReportPending/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  },                   
                  {
                    "Id_Item":5,
                    "Name":"Links",
                    "Path":"/link",
                    "Component":"link/",
                    "SubNavGroup":0,
                    "Sub_name":null
                  }
                  
                  ]
                }
          }
          catch(ex)
          {
            console.log(ex.message)
          }  
        }
    }

}
</script>
 